<template>
    <SideFormSection>
        <template #title> Weekly Hours </template>
        <template #rawContent>
            <Card
                title="Weekly Hours"
                iconName="calendar"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeAvailabilityUpdateWeeklyHoursUrl(
                                availability.id,
                            )
                        "
                        ref="apiFormRef"
                    >
                        <AvailabilityWeeklyHoursForm
                            :availability="availability"
                            :errors="
                                apiFormRef?.response?.getErrors() ??
                                new ApiFormErrors({})
                            "
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :disabled="availability.cannotBeManagedBy(companyUser)"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import Card from '@/Shared/Component/Card.vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import CompanyUser from '@/App/CompanyUser/Entity/CompanyUser'
    import Availability from '@/App/Availability/Entity/Availability'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import AvailabilityWeeklyHoursForm from '@/App/Availability/Component/AvailabilityWeeklyHoursForm.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import Button from '@/Shared/Component/Button.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'

    const props = defineProps({
        availability: {
            type: Object as PropType<Availability>,
            required: true,
        },
        companyUser: {
            type: Object as PropType<CompanyUser>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
